<template>
  <div class="article-footer">
    <div class="company">
      <div class="name">优与科技专注新能源汽车全生命周期管理咨询解决方案</div>
      <div class="address"
           v-on:click="goto('https://uri.amap.com/marker?position=121.43426,31.157514&name=徐锦记大厦')"><i class="el-icon-location"></i>公司地址：上海市徐汇区南宁路970号李锦记大厦901A</div>
      <div class="goto">
        <span v-on:click="goto('http://www.autobole.net/#/home')">官网入口 <i class="el-icon-d-arrow-right"></i></span>
      </div>
    </div>
    <div class="line"></div>
    <div class="beian">
      @沪ICP备案15009255号-1
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
$main_font_size: 0.16rem;
$main_line_height: 0.24rem;

$mobile_main_font_size: 0.26rem;
$mobile_main_line_height: 0.38rem;

.article-footer {
  width: 100%;
  height: 2.04rem;
  background: rgba(96, 96, 96, 1);
  padding: 0.2rem 0rem;
  .company {
    .name {
      font-size: $main_font_size;
      font-weight: 500;
      color: #fff;
      line-height: $main_line_height;
      letter-spacing: 1px;
    }

    .address {
      font-size: $main_font_size;
      font-weight: 400;
      color: #fff;
      line-height: $main_line_height;
      padding: 0.2rem;
      cursor: pointer;

      i {
        color: #fff;
        margin-right: 0.1rem;
      }
    }
  }

  .goto {
    font-size: $main_font_size;
    font-weight: 400;
    color: #fff;
    line-height: $main_line_height;
    span {
      cursor: pointer;
    }
  }
  .line {
    width: 100%;
    height: 1px;
    background: #7c7c7c;
    margin: 0.15rem 0;
  }
  .beian {
    font-size: 0.14rem;
    font-weight: 400;
    color: rgba(203, 203, 203, 1);
    line-height: 0.2rem;
    margin-top: 0.2rem;
    margin-bottom: 0.4rem;
    text-align: center;
  }

  .fixed_width {
    height: 100%;
    max-width: 1000px;
    margin: 0 auto;
  }

  @media only screen and (max-width: 750px) {
    .beian {
      font-size: 0.2rem;
    }
  }
}
</style>
